export default __webpack_public_path__ + "static/media/RTR1602V_Frente.168e6ae4.webp";